import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';

/**
 * @param {object} pluginConfig
 * @param {string} pluginConfig.id - Hotjar site ID
 */
export default function hotjarPlugin(pluginConfig) {
    consentManager.register(analyticsPluginName.hotjar, userPrivacySetting.analytic, () => {
        window.hj = window.hj || function() {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
        window._hjSettings = { hjid: pluginConfig.id, hjsv: 6 };

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
        document.head.appendChild(script);
    });

    return {
        name: analyticsPluginName.hotjar,
        config: pluginConfig,
        track: () => {},
    };
}
